/**
 * Service for managing device identification
 */
export class DeviceService {
  private static readonly DEVICE_ID_KEY = 'device_id';

  /**
   * Get or generate a unique device ID
   */
  static getDeviceId(): string {
    let deviceId = localStorage.getItem(this.DEVICE_ID_KEY);
    if (!deviceId) {
      deviceId = 'device_' + Math.random().toString(36).substring(2, 15);
      localStorage.setItem(this.DEVICE_ID_KEY, deviceId);
    }
    return deviceId;
  }

  /**
   * Clear the stored device ID
   */
  static clearDeviceId(): void {
    localStorage.removeItem(this.DEVICE_ID_KEY);
  }
}